import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ClapperboardIcon, MenuIcon, XIcon } from 'lucide-react';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);
  const navLinks = [{
    to: '/features',
    label: 'Features'
  }, {
    to: '/pricing',
    label: 'Pricing'
  }, {
    to: '/about',
    label: 'About'
  }];
  const isActive = (path: string) => location.pathname === path;
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-cream/95 backdrop-blur-md shadow-sm border-b border-parchment' : 'bg-cream/80 backdrop-blur-sm'}`} role="navigation" aria-label="Main navigation" data-id="element-56">
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-57">
        <div className="flex items-center justify-between h-16" data-id="element-58">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2.5 group" aria-label="Slate & Page home" data-id="element-59">
            
            <div className="w-8 h-8 bg-navy rounded-lg flex items-center justify-center group-hover:bg-navy-light transition-colors" data-id="element-60">
              <ClapperboardIcon className="w-4 h-4 text-amber" aria-hidden="true" data-id="element-61" />
              
            </div>
            <span className="font-serif font-semibold text-lg text-ink tracking-tight" data-id="element-62">
              Slate & Page
            </span>
          </Link>

          {/* Desktop Nav Links */}
          <div className="hidden md:flex items-center gap-8" data-id="element-63">
            {navLinks.map(link => <Link key={link.to} to={link.to} className={`font-sans text-sm transition-colors ${isActive(link.to) ? 'text-ink font-medium' : 'text-ink-muted hover:text-ink'}`} data-id="element-64">
              
                {link.label}
              </Link>)}
          </div>

          {/* Desktop Actions */}
          <div className="hidden md:flex items-center gap-4" data-id="element-65">
            <a href="#" className="font-sans text-sm text-ink-muted hover:text-ink transition-colors" data-id="element-66">
              
              Log In
            </a>
            <Link to="/waitlist" className="font-sans text-sm font-medium bg-amber hover:bg-amber-dark text-white px-5 py-2 rounded-full transition-colors shadow-sm" data-id="element-67">
              
              Join Waitlist
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 rounded-lg text-ink-muted hover:text-ink hover:bg-parchment transition-colors" onClick={() => setIsMobileOpen(!isMobileOpen)} aria-expanded={isMobileOpen} aria-label="Toggle mobile menu" data-id="element-68">
            
            {isMobileOpen ? <XIcon className="w-5 h-5" aria-hidden="true" data-id="element-69" /> : <MenuIcon className="w-5 h-5" aria-hidden="true" data-id="element-70" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileOpen && <div className="md:hidden bg-cream border-t border-parchment shadow-lg" data-id="element-71">
          <div className="px-6 py-4 space-y-1" data-id="element-72">
            {navLinks.map(link => <Link key={link.to} to={link.to} className={`block py-3 font-sans text-sm border-b border-parchment last:border-0 transition-colors ${isActive(link.to) ? 'text-ink font-medium' : 'text-ink-muted hover:text-ink'}`} data-id="element-73">
            
                {link.label}
              </Link>)}
            <div className="pt-4 flex flex-col gap-3" data-id="element-74">
              <a href="#" className="font-sans text-sm text-center text-ink-muted hover:text-ink py-2 transition-colors" data-id="element-75">
              
                Log In
              </a>
              <Link to="/waitlist" className="font-sans text-sm font-medium text-center bg-amber hover:bg-amber-dark text-white px-5 py-3 rounded-full transition-colors" data-id="element-76">
              
                Join Waitlist
              </Link>
            </div>
          </div>
        </div>}
    </nav>;
}